/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useParams, useRouter } from "next/navigation";
import PricingSection from "../../../components/pricing/PricingSection";
export default function PricingContent(param) {
    let { onClick } = param;
    const params = useParams();
    const router = useRouter();
    const handlePlanClick = (_plan)=>{
        if (onClick) {
            onClick(_plan.id);
            return;
        }
        router.push("".concat(process.env.NEXT_PUBLIC_CLIENT_URL, "/").concat(params === null || params === void 0 ? void 0 : params.lng, "/signup"));
    };
    return /*#__PURE__*/ _jsx(PricingSection, {
        mode: "landing",
        onPlanClick: handlePlanClick
    });
}
